import React from 'react';

import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button as ShadcnButton } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { iconShape } from '../../../../../../shared/types';
import { useConversations } from '../../../hooks';

const Button = ({ icon, label }) => {
  const { isLoadingActive: isLoading } = useConversations();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <ShadcnButton aria-label={label} disabled={isLoading} size="icon" variant="ghost">
          <FontAwesomeIcon icon={icon} />
        </ShadcnButton>
      </TooltipTrigger>

      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
};

Button.propTypes = {
  icon: iconShape.isRequired,
  label: PropTypes.string.isRequired,
};

export default Button;
